import React, { Component } from "react";
import {
  Input,
  Button,
  GridContainer,
  GridRow,
  GridColumn,
  Toastr,
  Utils,
  Modal,
  Select
} from "arv-reactcomponents";
import PropTypes from "prop-types";
import { Login, Analytics } from "arv-extends";
import { observer, inject } from "mobx-react";
import {
  CORPORATE_GIFTING_COMPONENTS,
  CIRCLE_PROGRAM
} from "npmlinks-constants";
import Banner from "../Banner";
import CircleOtp from "../CircleOtp";
import RequiredField from "../../RequiredField";
import DateComponent from "../../DateComponent";

const { EmailInput, MobileNumberInput } = Login;
const titlesList = JSON.parse(CIRCLE_PROGRAM.NAME_TITLES);
const { EventFactory: Event } = Analytics;

@inject("CommonStore")
@observer
class CircleForm extends Component {
  static getList(item) {
    return (
      <li className="nw-common-selectlist" key={item}>
        {item}
      </li>
    );
  }
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      pincode: "",
      isReciveUpdatesChecked: true,
      isWhatsAppNumberSame: false,
      dateOfBirth: "",
      selectedTitle: "Mr.",
      isOtpVerified: false,
      showOtpBlock: false
    };
    this.emailFields = null;
    this.mobileNoFields = null;
    this.WhatsAppMobileNoFields = null;
    this.updateValue = this.updateValue.bind(this);
    this.sendForm = this.sendForm.bind(this);
    this.getSelectSelection = this.getSelectSelection.bind(this);
  }
  updateValue(event, type) {
    const {
      target: { value }
    } = event;
    switch (type) {
      case "name":
        this.setState({ name: value });
        break;
      case "pincode":
        this.setState({ pincode: value });
        break;
      case "isReciveUpdatesChecked":
        this.setState({
          isReciveUpdatesChecked: !this.state.isReciveUpdatesChecked
        });
        break;
      case "isWhatsAppNumberSame":
        this.setState({
          isWhatsAppNumberSame: !this.state.isWhatsAppNumberSame
        });
        break;
      default:
        break;
    }
  }

  get finalFormData() {
    const {
      name,
      pincode,
      isReciveUpdatesChecked,
      isWhatsAppNumberSame,
      dateOfBirth,
      selectedTitle
    } = this.state;
    const finalWhatsAppNumber = isWhatsAppNumberSame
      ? this.mobileNoFields.state.mobileNumber
      : this.WhatsAppMobileNoFields.state.mobileNumber;

    return {
      name,
      email: this.emailFields.state.email,
      mobileNo: this.mobileNoFields.state.mobileNumber || "",
      whatsapp_number: finalWhatsAppNumber || "",
      pincode,
      isReciveUpdatesChecked,
      dateOfBirth,
      selectedTitle
    };
  }

  sendForm() {
    const { name, pincode, isWhatsAppNumberSame } = this.state;
    const finalWhatsAppNumber = isWhatsAppNumberSame
      ? this.mobileNoFields.state.mobileNumber
      : this.WhatsAppMobileNoFields.state.mobileNumber;
    if (
      !name ||
      !this.emailFields.state.isEmailInputValid ||
      !this.mobileNoFields.state.isMobileInputValid ||
      !finalWhatsAppNumber ||
      !pincode
    ) {
      Toastr.showToastr({
        className: "nwc-toastr-list-danger nw-toastr",
        message: CORPORATE_GIFTING_COMPONENTS.FORM_ERROR_MESSAGES.MANDATORY,
        timeout: 3000
      });
    } else if (!this.isNameValid) {
      Toastr.showToastr({
        className: "nwc-toastr-list-danger nw-toastr",
        message: CORPORATE_GIFTING_COMPONENTS.FORM_ERROR_MESSAGES.INVALID_NAME,
        timeout: 3000
      });
    } else if (
      (this.mobileNoFields.state.mobileNumber &&
        !this.mobileNoFields.state.isMobileInputValid) ||
      (!isWhatsAppNumberSame &&
        this.WhatsAppMobileNoFields.state.mobileNumber &&
        !this.WhatsAppMobileNoFields.state.isMobileInputValid)
    ) {
      Toastr.showToastr({
        className: "nwc-toastr-list-danger nw-toastr",
        message:
          CORPORATE_GIFTING_COMPONENTS.FORM_ERROR_MESSAGES.IMPROPER_PHONE,
        timeout: 3000
      });
    } else if (pincode && (pincode.length !== 6 || isNaN(pincode))) {
      Toastr.showToastr({
        className: "nwc-toastr-list-danger nw-toastr",
        message:
          CORPORATE_GIFTING_COMPONENTS.FORM_ERROR_MESSAGES.INVALID_PINCODE,
        timeout: 3000
      });
    } else if (
      !this.state.isOtpVerified &&
      this.mobileNoFields.state.mobileNumber &&
      this.mobileNoFields.state.isMobileInputValid
    ) {
      this.setState({ showOtpBlock: true });
      Analytics.default.trackEvent({
        action: Event.action.CIRCLE_SUBMIT_SUCCESS,
        category: Event.category.CIRCLE_SUBMIT_BTN
      });
    }
  }

  get checkboxIdSuffix() {
    const { isDesktop } = this.props.CommonStore;
    return isDesktop ? "desk" : "mob";
  }

  get isNameValid() {
    const { name } = this.state;
    return (
      name &&
      name.length > 0 &&
      name.match(/^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/i)
    );
  }

  get isWhatsAppFieldHidden() {
    return this.state.isWhatsAppNumberSame ? "wc-addmargin" : "";
  }

  closePopUp = () => {
    console.log("Pop Up closed");
    this.setState({ showOtpBlock: false });
  };

  getDOB = selectedDate => {
    const date = selectedDate && selectedDate.toLocaleDateString();
    this.setState({ dateOfBirth: date });
  };

  otpVerified = () => {
    this.setState({ isOtpVerified: true, showOtpBlock: false });
    this.props.CommonStore.triggerCircleProgram(this.finalFormData).then(
      () => {
        Toastr.showToastr({
          className: "nwc-toastr-list-success nw-toastr",
          message:
            CORPORATE_GIFTING_COMPONENTS.FORM_ERROR_MESSAGES.CIRCLE_SUCCESS,
          timeout: 3000
        });
        window.location.href = "/ppg/masks";
      },
      () => {
        Toastr.showToastr({
          className: "nwc-toastr-list-danger nw-toastr",
          message: CORPORATE_GIFTING_COMPONENTS.FORM_ERROR_MESSAGES.ERROR,
          timeout: 3000
        });
      }
    );
    console.log("otp verified");
  };

  getSelectSelection(selectedValue) {
    this.setState({
      selectedTitle: selectedValue
    });
  }

  render() {
    const {
      name,
      pincode,
      isReciveUpdatesChecked,
      isWhatsAppNumberSame,
      selectedTitle
    } = this.state;
    return (
      <GridContainer
        className={`wc-addmargin-form ${this.props.containerclassName} ${this.isWhatsAppFieldHidden}`}
        onClick={Utils.preventEventPropagation}
      >
        <GridRow className="nw-mobile-only">
          <GridColumn>
            <Banner
              text={CIRCLE_PROGRAM.REMARKS_FORM_TITLE}
              className="wc-banner-container"
            />
            <Banner
              text={CIRCLE_PROGRAM.REMARKS_FORM_SUBTITLE}
              className="wc-banner-container"
              textClassName="wc-banner-subtitle"
            />
          </GridColumn>
        </GridRow>
        <GridRow className="wc-remarksform-main">
          <GridColumn
            className={`nwc-grid-col-xs-12 wc-remarksform-container ${this.props.formclassName}`}
          >
            <form>
              <Banner
                text={CIRCLE_PROGRAM.REMARKS_FORM_TITLE}
                className="wc-banner-container nw-desktop-only"
              />
              <div>
                <Banner
                  text={CIRCLE_PROGRAM.REMARKS_FORM_SUBTITLE}
                  className="wc-banner-container nw-desktop-only"
                  textClassName="wc-banner-subtitle"
                />
                <div className="wc-circleform-name">
                  <Select
                    className="nwc-inp wc-remarksform-input wc-title-dropdown "
                    selectedValue={selectedTitle}
                    inpList={titlesList}
                    getSelection={this.getSelectSelection}
                    renderList={CircleForm.getList}
                  />
                  <RequiredField
                    className="nwc-inp  wc-remarksform-input wc-title-name"
                    required
                  >
                    <Input
                      name="name"
                      required="required"
                      type="text"
                      placeholder="Name"
                      value={name}
                      onChange={e => this.updateValue(e, "name")}
                    />
                  </RequiredField>
                </div>
              </div>
              <EmailInput.component
                className="wc-remarksform-input wc-remarksform-inputmargin"
                name="email"
                type="email"
                placeholder="Email"
                ref={values => {
                  this.emailFields = values;
                }}
                required
              />
              <MobileNumberInput.component
                className="wc-remarksform-input wc-remarksform-inputmargin"
                name="mobile-number"
                type="text"
                placeholder="Mobile Number"
                ref={values => {
                  this.mobileNoFields = values;
                }}
                required
              />
              {!isWhatsAppNumberSame ? (
                <MobileNumberInput.component
                  className="wc-remarksform-input wc-remarksform-inputmargin"
                  name="whatsapp-mobile-number"
                  type="text"
                  placeholder="Whatsapp Number"
                  ref={values => {
                    this.WhatsAppMobileNoFields = values;
                  }}
                  required
                />
              ) : null}
              <div className="wc-remarks-checboxcontainer">
                <Input
                  id={`whatapp-number-same-bool-${this.checkboxIdSuffix}`}
                  type="checkbox"
                  className="nwc-inp-checkbox-primary wc-remarksform-checkboxinp"
                  value="0"
                  checked={isWhatsAppNumberSame}
                  onChange={e => this.updateValue(e, "isWhatsAppNumberSame")}
                />
                <div>{CIRCLE_PROGRAM.REMARKS_FORM_WHATSAPP_NUMBER_TEXT}</div>
              </div>
              <div>
                <DateComponent
                  placeholderText="DD/MM/YYYY"
                  getDate={this.getDOB}
                  className="wc-date-picker"
                  labelText="Date Of Birth"
                  containerClassName="wc-date-container"
                  dateFormat="dd/MM/yyyy"
                  maxDate={new Date()}
                />
                <RequiredField
                  className="nwc-inp  wc-remarksform-input"
                  required
                >
                  <Input
                    className="wc-remarksform-input"
                    name="pincode"
                    type="text"
                    placeholder="Pincode"
                    value={pincode}
                    onChange={e => this.updateValue(e, "pincode")}
                  />
                </RequiredField>
              </div>
              <div className="wc-remarks-checboxcontainer">
                <Input
                  id="recieve-updates-bool"
                  type="checkbox"
                  className="nwc-inp-checkbox-primary wc-remarksform-checkboxinp"
                  value="0"
                  checked={isReciveUpdatesChecked}
                  onChange={e => this.updateValue(e, "isReciveUpdatesChecked")}
                />
                <div className="wc-remarksform-checkbox-text">
                  {CIRCLE_PROGRAM.REMARKS_FORM_RECIEVE_UPDATE_TEXT}
                </div>
              </div>
              <Button
                className="nwc-btn-primary wc-remarksform-btn"
                onClick={this.sendForm}
              >
                {CIRCLE_PROGRAM.REMARKS_FORM_BUTTON_TEXT}
              </Button>
            </form>
          </GridColumn>
        </GridRow>
        <Modal
          isOpen={this.state.showOtpBlock}
          onClose={this.closePopUp}
          className="wc-circle-otppopup"
        >
          {this.mobileNoFields && (
            <CircleOtp
              mobileNumber={this.mobileNoFields.state.mobileNumber}
              otpVerified={this.otpVerified}
            />
          )}
        </Modal>
      </GridContainer>
    );
  }
}

CircleForm.wrappedComponent.propTypes = {
  containerclassName: PropTypes.string.isRequired,
  formclassName: PropTypes.string.isRequired,
  CommonStore: PropTypes.shape({
    triggerCircleProgram: PropTypes.func.isRequired,
    isDesktop: PropTypes.bool.isRequired
  }).isRequired
};

export default CircleForm;
